export const EN_COPY = {
  "common.loading": "Loading…",
  "common.yes": "Yes",
  "common.no": "No",
  "common.notProvided": "Not provided",
  "common.notRequired": "Not required",
  "common.requested": "Requested",
  "nav.back": "Back",
  "nav.continue": "Continue",
  "nav.sendRequest": "Send request",
  "nav.sending": "Sending…",
  "alert.completeFields": "Please complete the highlighted fields before continuing.",
  "fill.filled": "Filled",
  "fill.notFound": "Not found",
  "fill.shipmentToo": "Shipment filled too: {detail}",
  "fill.palletMany": "pallets",

  "choose.title": "How would you like to request your quote?",
  "choose.manual.title": "Manual Entry",
  "choose.manual.description": "Enter your shipment details step by step using our guided form.",
  "choose.manual.action": "Enter details manually",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Paste your shipment details or upload a document, and we'll fill in the form for you.",
  "choose.quickfill.action": "Start Quick Fill",

  "steps.route": "Route & Order",
  "steps.shipment": "Shipment",
  "steps.services": "Additional services",
  "steps.contact": "Contact",
  "steps.review": "Review",

  "page.route": "Route and order",
  "page.routeSection": "Route",
  "page.shipment": "Shipment details",
  "page.services": "Additional services",
  "page.contact": "Contact details",
  "page.contactSection": "Your contact details",
  "page.review": "Review",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analyzing your document",

  "route.hintPostcode": "Enter a postcode or city for loading and for unloading.",
  "route.hintFullAddress": "Enter the full loading and unloading address.",
  "route.unsupported": "This route is not supported. Use the form for {loadCountry} and {unloadCountry}.",
  "route.loading": "Loading",
  "route.unloading": "Unloading",
  "route.origin": "Origin",
  "route.destination": "Destination",
  "route.country": "Country",
  "route.selectCountry": "Select country",
  "route.postcode": "Postcode",
  "route.postcodePlaceholder": "e.g. 3001 AA",
  "route.city": "City",
  "route.cityPlaceholder": "Enter city",
  "route.street": "Street name",
  "route.streetPlaceholder": "Enter street",
  "route.house": "Street number",
  "route.housePlaceholder": "e.g. 12",
  "route.pickupDate": "Preferred pickup date:",
  "route.unloadDate": "Preferred Unloading date:",
  "route.datePlaceholder": "dd/mm/yyyy",
  "date.clear": "Clear date",
  "date.closeCalendar": "Close calendar",
  "date.openCalendar": "Open calendar",
  "route.specificDateHint":
    "For goods released on a specific date. Otherwise, we will strive for the fastest option.",
  "route.orderDetails": "Order details",

  "shipment.goods": "Goods description",
  "shipment.goodsPlaceholder": "What would you like to transport?",
  "shipment.weight": "Total weight",
  "shipment.qty": "Qty",
  "shipment.type": "Type",
  "shipment.dims": "Dimensions / LDM",
  "shipment.stackable": "Stackable",
  "shipment.addRow": "Add shipment row",
  "shipment.totalLines": "Total article lines: {count}",
  "shipment.selectDims": "Select dimensions",
  "shipment.dimsNa": "Dimensions not applicable",
  "shipment.sizeModeDims": "L × W × H",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Remove shipment row {n}",
  "shipment.lineLabel": "{text}, line {n}",
  "shipment.quantity": "Quantity",
  "qty.decrease": "Decrease quantity",
  "qty.increase": "Increase quantity",
  "shipment.lengthCm": "Length (cm)",
  "shipment.widthCm": "Width (cm)",
  "shipment.heightCm": "Height (cm)",
  "shipment.dimensions": "Dimensions",
  "shipment.size": "Size",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Half pallet",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Custom",
  "pallet.unspecified": "LDM",

  "services.aria": "Additional services",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperature",
  "services.pill.tail": "Tail lift",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Time window",
  "services.pill.ref": "Reference / Notes",
  "services.pill.references": "References",
  "services.pill.attachments": "Additional attachments",
  "services.adrClass": "ADR class",
  "services.selectClass": "Select class",
  "services.unNumber": "UN number",
  "services.unPlaceholder": "e.g. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Tail Lift at loading",
  "services.tailUnload": "Tail Lift at unloading",
  "services.ftlCopy": "Full truck load requested.",
  "services.invoiceRef": "Invoice reference",
  "services.reference": "Reference",
  "services.loadingRef": "Loading reference",
  "services.unloadingRef": "Unloading reference",
  "services.notes": "Notes",
  "services.notesPlaceholder": "e.g. special instructions",
  "services.deadline": "Preferred Delivery deadline:",
  "services.deliveryHint":
    "For goods delivered on a specific date. Otherwise, we will strive for the fastest option.",
  "services.loadingTime": "Loading time",
  "services.unloadingTime": "Unloading time",
  "services.window": "Window",
  "services.fixed": "Fixed",
  "services.at": "at",
  "services.from": "from",
  "services.to": "to",
  "services.timeTypeAria": "{title} type",
  "services.addFiles": "Add files",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP or PDF. Up to {maxFiles} files, {maxFileMb} MB each, {maxTotalMb} MB total.",
  "services.adrClass1": "1 Explosives",
  "services.adrClass2": "2 Gases",
  "services.adrClass3": "3 Flammable liquids",
  "services.adrClass4": "4 Flammable solids",
  "services.adrClass5": "5 Oxidizing substances",
  "services.adrClass6": "6 Toxic / Infectious",
  "services.adrClass7": "7 Radioactive",
  "services.adrClass8": "8 Corrosive",
  "services.adrClass9": "9 Miscellaneous",
  "services.summary.adr": "Dangerous Goods (ADR)",
  "services.summary.temp": "Temperature Controlled",
  "services.summary.time": "Time Windows",
  "services.summary.refNotes": "Reference & notes",
  "services.summary.tail": "Tail Lift",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Additional attachments",
  "services.tail.loadUnload": "Loading & Unloading",
  "services.tail.loadOnly": "Loading only",
  "services.tail.unloadOnly": "Unloading only",
  "services.time.load": "Load: {value}",
  "services.time.unload": "Unload: {value}",
  "services.time.deadline": "Deadline: {value}",
  "services.time.fixedSuffix": "{time} (Fixed)",
  "services.time.windowRange": "{from} to {until}",
  "services.adr.yes": "Yes",
  "services.adr.classUn": "Class {class}, UN {un}",
  "services.adr.classOnly": "Class {class}",
  "services.adr.unOnly": "UN {un}",
  "services.temp.range": "{min}°C to {max}°C",
  "services.ref.invoice": "Invoice: {value}",
  "services.ref.loading": "Loading: {value}",
  "services.ref.unloading": "Unloading: {value}",

  "contact.name": "Name",
  "contact.company": "Company",
  "contact.email": "Email",
  "contact.phone": "Phone",
  "contact.comment": "Additional comment",
  "contact.privacyBefore":
    "I agree with the processing of my personal data in accordance with Neele-Vat's ",
  "contact.privacyLink": "privacy policy",
  "contact.privacyAfter": ".",

  "result.thankYou": "Thank you! Your request has been received.",
  "result.teamWillContact": "Our team will contact you within 60 minutes during office hours.",
  "result.teamWillContactEmail":
    "Our team will contact you within 60 minutes during office hours at {email}.",
  "result.previewMode": "Preview mode - this request was not actually sent.",
  "result.previewFiles": " Note: files cannot be sent in preview mode.",
  "result.yourReference": "Your reference",
  "result.copy": "Copy",
  "result.copied": "Copied",
  "result.nextTitle": "What happens next",
  "result.next1": "Request received.",
  "result.next2": "Request being reviewed.",
  "result.next3": "Response within 60 minutes via email.",
  "result.logged":
    "We've logged your request. If you don't hear from us shortly, please reach out using the details below.",
  "result.newQuote": "Start a new quote",
  "result.sendFailed": "We couldn't send your request",
  "result.preferDirect": "Prefer to reach us directly?",
  "result.backToEdit": "Back to edit",
  "result.tryAgain": "Try again",
  "result.hideDetails": "Hide details",
  "result.viewSent": "View what we sent",
  "result.error.rateLimited":
    "You've made a lot of requests in a short time. Please wait a moment and try again.",
  "result.error.forbidden":
    "This request was blocked. Please try again, or contact us directly using the details below.",
  "result.error.network":
    "We couldn't send your request just now. Please check your connection and try again.",
  "result.error.tooLarge":
    "This request is too large to send. Use smaller attachments or a shorter comment.",
  "result.error.unsupportedType": "Use JPEG, PNG, GIF, WebP, or PDF files only.",
  "result.error.emailUnavailable":
    "We couldn't email your request with the attachments. Please try again, or contact us directly.",

  "qf.hint":
    "Paste an email or shipment details, or attach an image or PDF. This replaces any details already entered.",
  "qf.placeholder":
    "e.g. 24 euro pallets from 3011 Rotterdam to 20095 Hamburg, 12.000 kg, pickup tomorrow…",
  "qf.ariaPaste": "Shipment details to analyze",
  "qf.attach": "Attach image or PDF",
  "qf.disclaimer":
    "Anything you paste or attach is used only to fill in this request. It is processed by our document analysis service and is not stored once the form is filled.",
  "qf.fillForm": "Fill form",
  "qf.working": "Working…",
  "qf.analyzing": "Analyzing your details…",
  "qf.noFields": "No fields could be extracted. Try adding more detail.",
  "qf.rateLimited": "You have made too many requests. Please wait a moment and try again.",
  "qf.blocked": "This request was blocked. Please contact us if this is unexpected.",
  "qf.extractUnavailable":
    "Document analysis is not available right now. Paste the shipment details instead.",
  "qf.genericError": "Something went wrong. Please check your network or try again.",
  "qf.analyzeTitle": "Analyzing your document...",
  "qf.analyzeSub": "This usually takes a few seconds",
  "qf.analyzeStep1": "Reading document structure",
  "qf.analyzeStep2": "Extracting basic details",
  "qf.analyzeStep3": "Identifying cargo lines",
  "qf.removeFile": "Remove {name}",

  "error.loadCountry": "Select a loading country.",
  "error.loadPostal": "Enter the loading postal code.",
  "error.loadCity": "Enter the loading city.",
  "error.loadStreet": "Enter the loading street name.",
  "error.loadHouseNumber": "Enter the loading street number.",
  "error.unloadCountry": "Select an unloading country.",
  "error.unloadPostal": "Enter the unloading postal code.",
  "error.unloadCity": "Enter the unloading city.",
  "error.unloadStreet": "Enter the unloading street name.",
  "error.unloadHouseNumber": "Enter the unloading street number.",
  "error.pickupDate": "Choose a pickup date.",
  "error.unloadDate": "Choose an unloading date.",
  "error.invalidDate": "Please enter a valid date.",
  "error.totalWeight": "Enter the total weight.",
  "error.goods": "Describe the goods.",
  "error.loadCityOrPostal": "Enter the loading postcode or city.",
  "error.unloadCityOrPostal": "Enter the unloading postcode or city.",
  "error.loadPostalInvalid": "Enter a recognised loading postcode.",
  "error.loadCityInvalid": "Enter a recognised loading city.",
  "error.unloadPostalInvalid": "Enter a recognised unloading postcode.",
  "error.unloadCityInvalid": "Enter a recognised unloading city.",
  "error.pickupPast": "Pickup date cannot be in the past.",
  "error.unloadPast": "Unloading date cannot be in the past.",
  "error.unloadBeforePickup": "Unloading date cannot be earlier than the pickup date.",
  "error.weightRange": "Enter a weight between 1 and {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Enter the 4-digit UN number.",
  "error.invoiceRef": "Enter the invoice reference.",
  "error.loadingRef": "Enter the loading reference.",
  "error.unloadingRef": "Enter the unloading reference.",
  "error.tempMin": "Enter the minimum temperature.",
  "error.tempMax": "Enter the maximum temperature.",
  "error.tempOrder": "Max must be at least min.",
  "error.enterNumber": "Enter a number.",
  "error.deliveryPast": "Delivery deadline cannot be in the past.",
  "error.deliveryBeforePickup": "Delivery deadline cannot be earlier than the pickup date.",
  "error.tailSides": "Select loading, unloading, or both.",
  "error.attachOne": "Attach at least one file.",
  "error.enterTime": "Enter a time.",
  "error.enterStartTime": "Enter a start time.",
  "error.enterEndTime": "Enter an end time.",
  "error.enterMinutes": "Enter the minutes.",
  "error.completeTime": "Enter a complete time.",
  "error.enterEmail": "Enter your email address.",
  "error.validEmail": "Enter a valid email address.",
  "error.validPhone": "Enter a valid phone number.",
  "error.personalEmail": "Personal email addresses are not accepted.",
  "error.enterName": "Enter your name.",
  "error.enterCompany": "Enter your company.",
  "error.privacy": "Please agree to continue.",
  "error.quickFillEmpty": "Paste shipment details or attach an image or PDF to fill the form.",
  "error.maxFiles": "You can attach up to {max} files.",
  "error.maxFileMb": "Each file must be {max} MB or smaller.",
  "error.maxTotalMb": "Attachments must be {max} MB or smaller in total.",
  "error.filesSkippedType": "Some files were skipped. Use JPEG, PNG, GIF, WebP, or PDF.",
  "error.emptySkipped": "Empty files were skipped.",
  "error.fileEmpty": "The selected file is empty.",
  "error.filesEmptyOrType": "Some files were empty or not a JPEG, PNG, GIF, WebP, or PDF.",
  "error.attachType": "Attach a JPEG, PNG, GIF, WebP, or PDF.",
  "error.subjectLong": "Subject is too long.",
  "error.emailTextLong": "Request details are too long.",
  "error.shortenSubject": "Shorten this value so the email subject stays within {max} characters.",
  "error.shortenBody":
    "Shorten the shipment details or comment so the email stays within {max} characters.",

  "announce.choose": "Choose how you'd like to request your quote",
  "announce.quickfill": "Quick Fill: paste details or upload a document",
  "announce.route": "Step 1 of 5: route and order",
  "announce.shipment": "Step 2 of 5: shipment details",
  "announce.services": "Step 3 of 5: additional services",
  "announce.contact": "Step 4 of 5: contact details",
  "announce.review": "Step 5 of 5: review your request",
  "announce.received": "Request received",
  "announce.sendFailed": "We couldn't send your request",
  "announce.sendFailedAttempt": "We couldn't send your request (attempt {n})",
  "announce.completeFields": "Please complete the highlighted fields before continuing.",
  "announce.sending": "Sending your request…",
} as const;
